import { mdiBookOpenVariant } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const Acordition = ({
    resources,
}: {
    resources:
        | {
              text: string
              link?: string
          }[]
        | undefined
}) => {
    const { t } = useTranslation()
    const color = useColorModeValue('var(--chakra-colors-gray-500)', 'var(--chakra-colors-white)')
    if (!resources) return

    const accordionItemText = t('global.helpCenter.accordition.title')

    return (
        <AccordionRoot
            defaultValue={[accordionItemText]}
            multiple
            mb="24px"
            backgroundColor="rgba(84, 79, 64, 0.08)"
            py="12px"
            border="none"
            px="24px"
        >
            <AccordionItem border="none" value={accordionItemText}>
                <h2>
                    <AccordionItemTrigger px="0" _hover={{ backgroundColor: 'transparent' }}>
                        <Icon path={mdiBookOpenVariant} size={1} color={color} />
                        <Box as="span" flex="1" textAlign="left" ml="12px" fontSize="12px" color={color} textTransform="uppercase">
                            {accordionItemText}
                        </Box>
                    </AccordionItemTrigger>
                </h2>
                <AccordionItemContent pb="0" pl="36px" pt="0">
                    {resources.map((item) => {
                        if (item.link)
                            return (
                                <Link display="block" key={item.text} href={item.link} isExternal fontSize="14px" fontWeight="400">
                                    {item.text}
                                </Link>
                            )
                        else
                            return (
                                <Text fontSize="14px" key={item.text}>
                                    {item.text}
                                </Text>
                            )
                    })}
                </AccordionItemContent>
            </AccordionItem>
        </AccordionRoot>
    )
}

export default Acordition
